import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, MenuComponent]
})
export class PageHeaderComponent {
    @Input() logoSrc: string = '/assets/images/BRAND2.png';
    @Input() logoWidth?: string;
}
